require('./brokerMarketsFinancesNewsView.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { Link } = require('react-router-dom');
const moment = require('moment');

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const { OKBoxNewPreview } = require('commonsComponents/OKBoxNewPreview');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { getFirstNWords } = require('utilities/stringHelper');
const { buildGridFinancesView, getClassGridContent } = require('utilities/brokerMarketsHelper');

// @constants
const {
    MAX_FINANCES_NEWS_VIEW
} = require('constants/brokerMarkets');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const BREADCRUMB = [
    {
        text: <FormattedText value="brokerMarketNews-savingsTitlte" />,
        url: '/myprofile/broker'
    },
    {
        text: <FormattedText value="broker-marketsTitle" />,
        url: '/myprofile/broker/markets'
    },
    {
        text: <FormattedText value="brokerMarketNews-financesNewsTitle" />,
        url: ''
    }
];

class BrokerMarketsFinancesNewsView extends React.Component {

    componentDidMount() {
        const { immBrokerMarket, requestFinancesNews } = this.props;

        if(immBrokerMarket.get('financesNews').length === 0)
            requestFinancesNews();
    }

    buildFirstImageGrid = (gridStyle, news, index) => {
        const { originCountry } = this.props;

        return (
            <div className={gridStyle.contentGridColClassName} key={index.toString()}>
                <div className={gridStyle.contentGridClassName}>
                    <OKBoxNewPreview
                        title={news.title1}
                        description={getFirstNWords(news.title2, 20)}
                        date={moment(news.creationDate).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_DATETIME)}
                        hasCover
                        coverImage={news.viewRef}
                        positionImage="LEFT"
                        heightImage={300}
                        linkContent={
                            <Link to={`/myprofile/broker/markets/finances-news-detail/${encodeURIComponent(news.title1)}`}>
                                <FormattedText value="brokerMarketNews-readMoreNews" />
                            </Link>
                        }
                    />
                </div>
            </div>
        )
    }

    buildGridContent = () => {
        const { immBrokerMarket, originCountry } = this.props;
        let countNews = 0;

        return buildGridFinancesView(immBrokerMarket.get('financesNews').slice(0, MAX_FINANCES_NEWS_VIEW).map((news, index) => {
            const gridStyle = getClassGridContent(countNews);
            if (index !== 0) {
                countNews += 1;
                return (
                    <div className={gridStyle.contentGridColClassName} key={index.toString()}>
                        <div className={gridStyle.contentGridClassName}>
                            <div className="box-news">
                                <OKBoxNewPreview
                                    title={news.title1}
                                    description={getFirstNWords(news.title2)}
                                    date={moment(news.creationDate).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_DATETIME)}
                                    hasCover
                                    coverImage={news.viewRef}
                                    linkContent={
                                        <Link to={`/myprofile/broker/markets/finances-news-detail/${encodeURIComponent(news.title1)}`}>
                                            <FormattedText value="brokerMarketNews-readMoreNews" />
                                        </Link>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                )
            } else {
                countNews += 1;
                return this.buildFirstImageGrid(gridStyle, news, index)
            }
        }));
    }

    buildLoadingErrorContentFinancesNews = () => {
        const { immBrokerMarket } = this.props;
        const loading =  immBrokerMarket.get('fetchingFinancesNews');
        const error = immBrokerMarket.get('errorFinancesNews');

        return (
            <OKLoadingErrorMessage
                isLoading={loading}
                isError={error}
            >
                {this.buildGridContent()}
            </OKLoadingErrorMessage>
        );
    }

    render() {
        const grid = this.buildLoadingErrorContentFinancesNews();

        return (
            <div className="broker-markets-finances-news">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={BREADCRUMB}
                                finalTitle={<FormattedText value="brokerMarketNews-financesNewsTitle" />}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>

                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="broker-markets-finances-news__box-news">
                                <OKBoxSectionContent
                                    className="row"
                                    content={grid}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsFinancesNewsView.propTypes = {
    immBrokerMarket: PropTypes.object,
    requestFinancesNews: PropTypes.func,
    originCountry: PropTypes.object
};

module.exports.constructor = BrokerMarketsFinancesNewsView;
module.exports.BrokerMarketsFinancesNewsView = connect(
    state => ({
        immBrokerMarket: state.brokerMarkets,
        originCountry: state.profile.get('originCountry')
    }), {
        requestFinancesNews: brokerMarketsActions.requestFinancesNews
})(BrokerMarketsFinancesNewsView);
